import React from 'react';

import FeaturedCategory from '../components/featured';

const FeaturedPage = () => {
    return (
        <FeaturedCategory />
    )
}

export default FeaturedPage;


// WEBPACK FOOTER //
// ./src/containers/featured-page.js